// iter417 — Single host for all dashboard modal/dialog mounts.
// Pulls the trailing five-portal block out of DashboardPage.jsx so the
// page render returns a flatter tree. State stays on the parent and
// flows in via props (controlled-component pattern).
//
// Includes:
//   • BranchPaybackDialog          — record an inter-branch payback
//   • WhatsAppSendDialog           — send the daily-sales digest
//   • WidgetSettingsDialog         — toggle which widgets render
//   • DashboardTour (conditional)  — first-run onboarding overlay
//   • DuesDetailDialog             — drill-down on supplier dues
import { BranchPaybackDialog } from './BranchPaybackDialog';
import { WidgetSettingsDialog } from './WidgetSettingsDialog';
import { DuesDetailDialog } from './DuesDetailDialog';
import { WhatsAppSendDialog } from '@/components/WhatsAppSendDialog';
import DashboardTour from '@/components/DashboardTour';
import { WIDGET_OPTIONS } from '@/components/dashboard/dashboardConstants';

export function DashboardModalsHost({
  // Payback
  showPayback, setShowPayback, branches = [], onPaybackSuccess,
  // WhatsApp
  showWhatsApp, setShowWhatsApp,
  // Widget settings
  showWidgetSettings, setShowWidgetSettings,
  widgets, setWidgets, toggleWidget, tr,
  // Tour
  showTour, onTourComplete, language,
  // Dues detail
  showDuesDetail, setShowDuesDetail, duesDetailData = [],
}) {
  return (
    <>
      <BranchPaybackDialog
        open={showPayback}
        onOpenChange={setShowPayback}
        branches={branches}
        onSuccess={onPaybackSuccess}
      />
      <WhatsAppSendDialog
        open={showWhatsApp}
        onClose={() => setShowWhatsApp(false)}
        defaultType="daily_sales"
        branches={branches}
      />
      <WidgetSettingsDialog
        open={showWidgetSettings}
        onOpenChange={setShowWidgetSettings}
        widgets={widgets}
        setWidgets={setWidgets}
        toggleWidget={toggleWidget}
        options={WIDGET_OPTIONS}
        tr={tr}
      />
      {showTour && <DashboardTour onComplete={onTourComplete} language={language} />}
      <DuesDetailDialog
        open={showDuesDetail}
        onOpenChange={setShowDuesDetail}
        data={duesDetailData}
      />
    </>
  );
}

export default DashboardModalsHost;
